 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import HALF_TITLE from '@/components/half_title'
 import TITLE from '@/components/title'
 import COPYRIGHT from '@/components/copyright'
 import DEDICATION from '@/components/dedication'
 import CONTENTS from '@/components/contents'
 import PLATES_AND_MAPS from '@/components/plates_and_maps'
 import FOREWORD from '@/components/foreword'
 import PLATE_SECTION from '@/components/plate_section'
 import INTRODUCTION from '@/components/introduction'
 import CH1 from '@/components/ch1'
 import CH2 from '@/components/ch2'
 import CH3 from '@/components/ch3'
 import CH4 from '@/components/ch4'
 import CH5 from '@/components/ch5'
 import CH6 from '@/components/ch6'
 import CH7 from '@/components/ch7'
 import CH8 from '@/components/ch8'
 import CH9 from '@/components/ch9'
 import CH10 from '@/components/ch10'
 import CH11 from '@/components/ch11'
 import APPENDIX_1 from '@/components/appendix_1'
 import APPENDIX_2 from '@/components/appendix_2'
 import APPENDIX_3 from '@/components/appendix_3'
 import GLOSSARY from '@/components/glossary'
 import NOTES from '@/components/notes'
 import SELECT_BIBLIOGRAPHY from '@/components/select_bibliography'
 import INDEX from '@/components/index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/half_title",
 			"name" : "half_title",
 			"component" : HALF_TITLE
 		},
 		{
 			"path" : "/title",
 			"name" : "title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/plates_and_maps",
 			"name" : "plates_and_maps",
 			"component" : PLATES_AND_MAPS
 		},
 		{
 			"path" : "/foreword",
 			"name" : "foreword",
 			"component" : FOREWORD
 		},
 		{
 			"path" : "/plate_section",
 			"name" : "plate_section",
 			"component" : PLATE_SECTION
 		},
 		{
 			"path" : "/introduction",
 			"name" : "introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/ch1",
 			"name" : "ch1",
 			"component" : CH1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js